var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.title
        ? _c("base-title", { staticClass: "_pa-2", attrs: { level: "h3" } }, [
            _vm._v(_vm._s(_vm.title)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.navigationItems, function (item) {
        return _c(
          "div",
          {
            key: item.name,
            class: [
              "_flex _pa-2 _ai-c _jc-fs gfu-link-underline _bl-3 _pos-r",
              { "_bc--accent": item.isActive },
            ],
          },
          [
            item.isRestricted
              ? _c(
                  "tooltip",
                  {
                    attrs: {
                      text: item.restrictionReason,
                      "vertical-position": "down",
                    },
                  },
                  [
                    _c("span", { staticClass: "_tc--light" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                  ]
                )
              : _c("a", { key: item.name, attrs: { href: item.url } }, [
                  _vm._v("\n            " + _vm._s(item.name) + "\n        "),
                ]),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }